// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/styles/core.scss
// module id = 469
// module chunks = 2